import { Chakra } from "@airhelp/react-ui-components";
import { SearchIcon } from "styles/icons";
import type { FilterProps } from "./Filter.d";

const { InputGroup, Input, InputRightElement } = Chakra;

const Filter = ({ filter, setFilter, placeholder }: FilterProps) => (
  <InputGroup mt={{ base: 4, md: 0 }} w={{ base: "full", md: 60 }}>
    <Input
      border="1px"
      borderColor="greyscale.400"
      color="greyscale.500"
      fontSize="md"
      type="text"
      value={filter || ""}
      onChange={({ target: { value } }) => setFilter(value)}
      placeholder={placeholder}
    />
    <InputRightElement>
      <SearchIcon w={4} h={4} mt={1} />
    </InputRightElement>
  </InputGroup>
);

export default Filter;
